export default "__VITE_ASSET__ed98bae6__"